<template>
  <el-dialog title="提现数据" width="1100px" class="my-dialog-template" :visible.sync="visible" top="0">
    <el-table :data="tableData" style="width: 100%" border class="list-table" v-loading="listLoading" tooltip-effect="dark">
      <el-table-column label="结算主体" min-width="240px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ all.SUB_COMPANY_ID[scope.row.subCompanyId] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="结算期次" width="100" :show-overflow-tooltip="true">
        <template slot-scope="{ row }">
          {{ row.num == 1 ? '首期' : '第' + row.num + '期' }}
        </template>
      </el-table-column>
      <el-table-column prop="policyFeeSum" label="总保费（元）" :show-overflow-tooltip="true" min-width="120px"></el-table-column>
      <el-table-column prop="policyNum" label="保单数" :show-overflow-tooltip="true" min-width="80px"></el-table-column>
      <el-table-column prop="policyIncomes" label="应结费用（元）" :show-overflow-tooltip="true" min-width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.policyIncomes }}</span>
          <activityTip v-if="scope.row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="scope.row.activityIncomes"></activityTip>
        </template>
      </el-table-column>
      <el-table-column prop="incomeTax" label="实际收入（元）" :show-overflow-tooltip="true" min-width="140px"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button-group>
            <el-button type="text" @click="jumpWithdrawMX(scope.row)">明细</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="dialog-footer" v-if="mechanUserType == 1">
      <el-button type="warning" class="bgBtn" @click="downloadFile()">结算函及明细下载</el-button>
    </div>
    <div class="dialog-footer" v-else>
      <el-button type="warning" plain @click="visible = false">取消</el-button>
      <el-button type="warning" class="bgBtn" @click="submit()">确定提现</el-button>
    </div>
  </el-dialog>
</template>
<script>
import topSearchForm from '@/components/topSearchForm';
import activityTip from '@/components/activityTip';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  components: {
    topSearchForm,
    activityTip
  },
  data: () => ({
    visible: false,
    loading: false,
    all: {},
    mechanUserType: '', //1机构2，3个人
    level: '',
    operation: '',
    searchParams: {}
  }),
  created() {
    const user = this.$tools.getLocal('userinfo');
    this.mechanUserType = user.mechanUserType; //1机构2，3个人
    this.level = user.level; //1机构2，3个人
    this.$tools.getall(data => {
      this.all = data;
    });
  },
  methods: {
    async open(operation, params = {}) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.searchParams = {};
      try {
        this.operation = operation;
        if (operation == 'add') {
          this.searchParams.balanceIds = params.balanceIds;
          if (this.level != 1) {
            // 下级机构直接提现
            this.$emit('submit', {
              balanceIds: this.searchParams.balanceIds
            });
            return;
          } else if (this.mechanUserType == 1) {
            try {
              // 企业
              await this.generateWithdraw();
            } catch (error) {
              this.loading = false;
              return;
              console.log(error);
            }
          }
        } else {
          this.searchParams.cashPostalId = params.id;
        }
        this.visible = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
      this.initListAjax('/master/means/getMergeNotAppliedBalances');
    },
    // 生成提现数据
    generateWithdraw() {
      return this.$http({
        url: '/master/means/generateWaitUploadWithdraw',
        type: 'put',
        params: {
          balanceIds: this.searchParams.balanceIds
        }
      }).then(res => {
        this.$emit('reload');
        this.searchParams.cashPostalId = res.data.id;
      });
    },
    //提交
    submit() {
      this.$emit('submit', {
        balanceIds: this.searchParams.balanceIds
      });
      this.visible = false;
    },
    // 设置自定义参数
    setListParams(params) {
      params.pageSize = 999;
      this.$tools.delNull(params);
    },
    // 跳转提现明细
    jumpWithdrawMX(row) {
      var rou = this.$router.resolve({
        path: '/settlementDetail',
        query: {
          fromPage: 'withdraw',
          title: this.all.SUB_COMPANY_ID[row.subCompanyId] + '——' + (row.num == 1 ? '首期' : '第' + row.num + '期'),
          balanceIds: row.balanceIds.join(',')
        }
      });
      window.open(rou.href, '_blank');
    },
    // 下载结算函
    downloadFile() {
      this.daochu('/master/means/balanceConfirmDownload', {
        cashPostalId: this.searchParams.cashPostalId
      });
      this.jumpWithdraw('下载成功');
    },
    daochu(url, params) {
      this.$http({
        url: url,
        forced: true,
        responseType: 'blob',
        All: true,
        params: params,
        type: 'get'
      }).then(res => {
        this.$tools.daochuDownload(res);
      });
    },
    jumpWithdraw(title) {
      if (this.operation == 'add') {
        window.setTimeout(() =>{
          this.$confirm('可前往提现记录查看待上传发票的提现记录，上传发票等资料。', title, {
            confirmButtonText: '立即前往',
            cancelButtonText: '返回',
            type: 'warning'
          }).then(() => {
            this.visible = false;
            this.$emit('jumpWithdraw');
          });
        }, 2000);
      } else {
        this.visible = false;
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-table {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
  }
  .el-table::before {
    display: none;
  }
  .el-table__empty-block {
    border-bottom: 1px solid #ebeef5;
  }
  .el-table__header-wrapper {
    position: sticky;
    top: 0;
    z-index: 5;
  }
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .jgheader {
    margin-bottom: 20px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .dialog-footer {
    margin-top: 30px;
  }
  .yichang {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: #fff;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 15px;
    font-size: 14px;
    cursor: pointer;
  }
  .title-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .el-dialog__title {
      margin-right: 20px;
    }
  }
}
</style>